export const basicCoverageDetailId = 135

export const lossDetailsFormName = "Loss Details"
export const payoutFormName = "Claims Payout Instruction"
export const reviewFormName = "Review Page"
